import { createPortal } from 'react-dom'

import { Skeleton } from '@/components/ui'
import { SIDEBAR_COLLAPSED_WIDTH } from '../../utils/chatPrefs'
import { useRightRailTarget } from './useRightRailTarget'

// Holds the collapsed rail's width while the project loads, so the page doesn't narrow when the
// real sidebar mounts. Mirrors CollapsedRail: the chat mark with its label, then the icon buttons.
export default function ChatRailSkeleton() {
  const target = useRightRailTarget()

  if (!target) return null

  return createPortal(
    <aside
      className="relative hidden h-full shrink-0 flex-col items-center gap-2 border-l bg-background py-4 lg:flex"
      style={{ width: SIDEBAR_COLLAPSED_WIDTH }}
    >
      <div className="flex flex-col items-center gap-1">
        <Skeleton className="h-9 w-9 rounded-lg" />
        <Skeleton className="h-2.5 w-8" />
      </div>

      <div className="my-1 h-px w-6 bg-border" aria-hidden="true" />

      <Skeleton className="h-8 w-8 rounded-md" />
      <Skeleton className="h-8 w-8 rounded-md" />
    </aside>,
    target,
  )
}
